export enum IBreakdownOverallStatus {
  NoBreakdown = 'NO_BREAKDOWN',
  NoBreakdownCompare = 'NO_BREAKDOWN_COMPARE',
  BreakdownOverall = 'BREAKDOWN_OVERALL',
  BreakdownOverallCompare = 'BREAKDOWN_OVERALL_COMPARE',
  BreakdownNotOverall = 'BREAKDOWN_NOT_OVERALL',
}

export enum SortingKindEnum {
  DATE = 'DATE',
  NAME = 'NAME',
  TYPE = 'TYPE',
  CREATION_DATE = 'CREATION TIME',
  EDIT_DATE = 'EDIT TIME',
  CREATOR = 'CREATOR',
  EDITOR = 'EDITOR',
  KEY = 'KEY',
  ALERTONLY = 'ALERTONLY',
  KIND = 'KIND',
  EMAIL = 'EMAIL',
  LAST_LOGIN = 'LAST LOGIN',
  TAGS = 'TAGS',
  FAVORITE = 'FAVORITE',
  DESCRIPTION = 'DESCRIPTION',
}

// use for map redux-dictionary
export enum DictionaryTypeEnum {
  DictionaryMeasure = 'measure',
  DictionaryCohort = 'cohort',
  DictionaryEvent = 'event',
  DictionaryVirtualEvent = 'virtualEvent',
  DictionaryFilter = 'filter',
  DictionaryField = 'field',
  DictionaryBuckets = 'buckets',
  CalendarIncident = 'calendarIncident',
  ScheduleDashboard = 'scheduleDashboard',
  ScheduleCohort = 'scheduleCohort',
  ScheduleAnalysis = 'scheduleAnalysis',
  Users = 'users',
  UserGroups = 'userGroups',
  Roles = 'roles',
}

export enum YAxisCustomizationType {
  LOG = 'log',
  LINEAR = 'linear',
  QUANTILE = 'quantile',
}

export type LogBase = number | 'e';

export interface ILogYAxisCustomization {
  type: YAxisCustomizationType.LOG;
  logBase: LogBase;
}

export interface IQuantileYAxisCustomization {
  type: YAxisCustomizationType.QUANTILE;
  quantile: number;
}

export interface ILinerYAxisCustomization {
  type: YAxisCustomizationType.LINEAR;
  minValue?: number;
  maxValue?: number;
}

export type IYAxisCustomization =
  | ILogYAxisCustomization
  | IQuantileYAxisCustomization
  | ILinerYAxisCustomization;

export type MaybeNil<T> = T | null | undefined;
